import { AnimationCloud } from 'components/cloud/AnimationCloud';

import cn from 'templates/Template.module.scss';
const { PUBLIC_URL } = process.env;

export const ComingSoon = () => {
  return (
    <div className={cn.public}>
      <AnimationCloud>
        <div className={cn.logo}>
          <img src={`${PUBLIC_URL}/voladeum/voladeum-vertical.png`} alt="Voladeum" />
        </div>
      </AnimationCloud>
    </div>
  );
};
